import React from 'react';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { useIsEmbeddedMobile } from '../../../../_hooks/useIsEmbeddedMobile';

interface Props {
  title?: string;
  children: React.ReactNode;
}

export const TabHeaderSkeleton: React.FC<Props> = ({ title, children }) => {
  const isEmbeddedMobile = useIsEmbeddedMobile();
  return (
    <Box display={isEmbeddedMobile ? 'block' : 'flex'} justifyContent="space-between" mx="8">
      <Text as="h1" fontSize="h5" fontWeight={600} isTruncated>
        {title || ''}
      </Text>
      <Box mt={isEmbeddedMobile ? 4 : 0}>{children}</Box>
    </Box>
  );
};
